import React from "react";
import {
  ApiCallComponent,
  BodyPara,
  DescMain,
  Header,
  QueryPara,
  RequestUrl,
  ResponseComp,
  SubDescMain,
} from "./DocsComponent";
import {
  geoCodeDropoff,
  geoCodeMain,
  geoCodePickup,
} from "./V2/geocodes/Description";
import { geoDropoffQueryTab, geoPickupQueryTab } from "./V2/geocodes/Table";
import {
  oneWayMain,
  onewayBookingWithVehicleDatas,
  onewayVehiclePricesDatas,
  onewaysearchIdDatas,
} from "./V2/SearchId/Oneway/Description";
import {
  OnewayBookingWithVehicleBodyTab,
  OnewayBookingWithVehicleQueryTab,
  OnewaySearchIdBodyTab,
  OnewaySearchIdQueryTab,
  OnewayVehicleWithPriceQueryTab,
} from "./V2/SearchId/Oneway/Table";
import {
  hourlyBookingWithVehicleDatas,
  hourlyMain,
  hourlyVehiclePricesDatas,
  hourlysearchIdDatas,
} from "./V2/SearchId/Hourly/Description";
import {
  HourlyBookingWithVehicleBodyTab,
  HourlyBookingWithVehicleQueryTab,
  HourlySearchIdBodyTab,
  HourlySearchIdQueryTab,
  HourlyVehicleWithPriceQueryTab,
} from "./V2/SearchId/Hourly/Table";
import { cancelBookingDatas } from "./V2/CancelBooking/Description";
import {
  CancelBookingQueryTab,
  CancelBookingbodyTab,
} from "./V2/CancelBooking/Table";
import { DriverDetailsQueryTab } from "./V2/Tracking&DriverDetails/Table";
import { DriverDetailsAndTrackingDatas } from "./V2/Tracking&DriverDetails/Description";
import {
  onewayBookingWithVehicleCodeImplementation,
  onewaySearchId,
  onewaySearchIdCodeImplementation,
  onewayVehicleWithPrice,
  onewaybookingCode,
  onewaypriceWithVehicleCodeImplementation,
} from "./V2/SearchId/Oneway/Code";
import {
  geocodeDropoffCodeImplementation,
  geocodePickupCode,
  geocodePickupCodeImplementation,
  geocodedropCodeOff,
} from "./V2/geocodes/Code";
import { Authentication, Overview } from "./V2/Overview/Description";
import {
  hourlyBookingWithVehicleCodeImplementation,
  hourlyPriceWithVehicleCodeImplementation,
  hourlySearchId,
  hourlySearchIdCodeImplementation,
  hourlyVehicleWithPrice,
  hourlybookingCode,
} from "./V2/SearchId/Hourly/Code";
import {
  cancelBookingCode,
  cancelBookingCodeImplementation,
} from "./V2/CancelBooking/Code";
import {
  trackingAndDriverDetailsCode,
  trackingAndDriverDetailsCodeImplementation,
} from "./V2/Tracking&DriverDetails/Code";
import { BookingStatusDatas } from "./V2/BookingDetails/Description";
import {
  BookingDetailsQueryTab,
  BookingDetailsbodyTab,
} from "./V2/BookingDetails/Table";
import {
  BookingDetailsCode,
  BookingDetailsCodeImplementation,
} from "./V2/BookingDetails/Code";

const DescriptionV2 = () => {
  return (
    <div className="space-y-6">
      <DescMain header={"Overview"} id={"Overview"}>
        {Overview}
      </DescMain>
      <DescMain header={"Authentication"} id={"Authentication"}>
        <SubDescMain header={"Account Creation"}>
          {Authentication.AccountCreation}
        </SubDescMain>
        <SubDescMain header={"API Authentication"}>
          {Authentication.API_Authentication}
        </SubDescMain>
        <SubDescMain header={"Support"}>{Authentication.Support}</SubDescMain>
      </DescMain>

      {/* Geocodes */}
      <DescMain header={"Geocodes"} id="Geocodes Main">
        <div>{geoCodeMain}</div>

        <SubDescMain
          id={"Geocodes For Pickup"}
          header={"1. Geocodes (Latitude And Longitude) For Pickup"}
        >
          {geoCodePickup.intro}
          <RequestUrl title={geoCodePickup.endpoint} reqType={"GET"} />
          <Header />
          <BodyPara bodyEmpty={true} />
          <QueryPara
            queryEmpty={false}
            bodyTabHeader={geoPickupQueryTab.HeaderTable}
            bodyTableValues={geoPickupQueryTab.HeaderBodyTable}
          />
          <ApiCallComponent
            AllCodeImplementation={geocodePickupCodeImplementation}
            title={"Geocodes For Pickup"}
          />
          <ResponseComp
            responseDescription={geoCodePickup.responseDes}
            responsePayload={geocodePickupCode.response}
          />
        </SubDescMain>

        <SubDescMain
          id={"Geocodes For Drop-Off"}
          header={"2. Geocodes (Latitude And Longitude) For Dropoff"}
        >
          {geoCodeDropoff.intro}
          <RequestUrl title={geoCodeDropoff.endpoint} reqType={"GET"} />
          <Header />
          <BodyPara bodyEmpty={true} />
          <QueryPara
            queryEmpty={false}
            bodyTabHeader={geoDropoffQueryTab.HeaderTable}
            bodyTableValues={geoDropoffQueryTab.HeaderBodyTable}
          />
          <ApiCallComponent
            AllCodeImplementation={geocodeDropoffCodeImplementation}
            title={"Geocodes For Drop-Off"}
          />
          <ResponseComp
            responseDescription={geoCodeDropoff.responseDes}
            responsePayload={geocodedropCodeOff.response}
          />
        </SubDescMain>
      </DescMain>

      {/* Oneway */}
      <DescMain header={"Oneway"} id="Oneway Main">
        {oneWayMain}
        <SubDescMain
          id={"Generate Search Id_OW"}
          header={"3.Generate Search Id (Oneway)"}
        >
          {onewaysearchIdDatas.intro}
          <RequestUrl title={onewaysearchIdDatas.endpoint} reqType={"POST"} />
          <Header />
          <BodyPara
            bodyEmpty={false}
            bodyTabHeader={OnewaySearchIdBodyTab.HeaderTable}
            bodyTableValues={OnewaySearchIdBodyTab.HeaderBodyTable}
            bodyPayload={onewaySearchId.body}
          />
          <QueryPara
            queryEmpty={false}
            bodyTabHeader={OnewaySearchIdQueryTab.HeaderTable}
            bodyTableValues={OnewaySearchIdQueryTab.HeaderBodyTable}
          />

          <ApiCallComponent
            AllCodeImplementation={onewaySearchIdCodeImplementation}
            title={"Generate Search Id (Oneway)"}
          />
          <ResponseComp
            responseDescription={onewaysearchIdDatas.responseDes}
            responsePayload={onewaySearchId.response}
          />
        </SubDescMain>

        <SubDescMain
          id={"Price With Vehicle_OW"}
          header={"4.Price With Vehicle (Oneway)"}
        >
          {onewayVehiclePricesDatas.intro}
          <RequestUrl
            title={onewayVehiclePricesDatas.endpoint}
            reqType={"GET"}
          />
          <Header />
          <BodyPara bodyEmpty={true} />
          <QueryPara
            queryEmpty={false}
            bodyTabHeader={OnewayVehicleWithPriceQueryTab.HeaderTable}
            bodyTableValues={OnewayVehicleWithPriceQueryTab.HeaderBodyTable}
          />
          <ApiCallComponent
            AllCodeImplementation={onewaypriceWithVehicleCodeImplementation}
            title={"Price With Vehicle (Oneway)"}
          />
          <ResponseComp
            responseDescription={onewayVehiclePricesDatas.responseDes}
            responsePayload={onewayVehicleWithPrice.response}
          />
        </SubDescMain>

        <SubDescMain
          id={"Booking With Vehicle_OW"}
          header={"5.Booking With Vehicle (Oneway)"}
        >
          {onewayBookingWithVehicleDatas.intro}
          <RequestUrl
            title={onewayBookingWithVehicleDatas.endpoint}
            reqType={"POST"}
          />
          <Header />
          <BodyPara
            bodyEmpty={false}
            bodyTabHeader={OnewayBookingWithVehicleBodyTab.HeaderTable}
            bodyTableValues={OnewayBookingWithVehicleBodyTab.HeaderBodyTable}
            bodyPayload={onewaybookingCode.body}
          />
          <QueryPara
            queryEmpty={false}
            bodyTabHeader={OnewayBookingWithVehicleQueryTab.HeaderTable}
            bodyTableValues={OnewayBookingWithVehicleQueryTab.HeaderBodyTable}
          />
          <ApiCallComponent
            AllCodeImplementation={onewayBookingWithVehicleCodeImplementation}
            title={"Booking With Vehicle (Oneway)"}
          />
          <ResponseComp
            responseDescription={onewayBookingWithVehicleDatas.responseDes}
            responsePayload={onewaybookingCode.response}
          />
        </SubDescMain>
      </DescMain>

      <DescMain header={"Hourly"} id="Hourly Main">
        {hourlyMain}
        <SubDescMain
          id={"Generate Search Id_HR"}
          header={"6.Generate Search Id (Hourly)"}
        >
          {hourlysearchIdDatas.intro}
          <RequestUrl title={hourlysearchIdDatas.endpoint} reqType={"POST"} />
          <Header />
          <BodyPara
            bodyEmpty={false}
            bodyTabHeader={HourlySearchIdBodyTab.HeaderTable}
            bodyTableValues={HourlySearchIdBodyTab.HeaderBodyTable}
            bodyPayload={hourlySearchId.body}
          />
          <QueryPara
            queryEmpty={false}
            bodyTabHeader={HourlySearchIdQueryTab.HeaderTable}
            bodyTableValues={HourlySearchIdQueryTab.HeaderBodyTable}
          />
          <ApiCallComponent
            AllCodeImplementation={hourlySearchIdCodeImplementation}
            title={"Generate Search Id (Hourly)"}
          />
          <ResponseComp
            responseDescription={hourlysearchIdDatas.responseDes}
            responsePayload={hourlySearchId.response}
          />
        </SubDescMain>

        <SubDescMain
          id={"Price With Vehicle_HR"}
          header={"7.Price With Vehicle (Hourly)"}
        >
          {hourlyVehiclePricesDatas.intro}
          <RequestUrl
            title={hourlyVehiclePricesDatas.endpoint}
            reqType={"GET"}
          />
          <Header />
          <BodyPara bodyEmpty={true} />
          <QueryPara
            queryEmpty={false}
            bodyTabHeader={HourlyVehicleWithPriceQueryTab.HeaderTable}
            bodyTableValues={HourlyVehicleWithPriceQueryTab.HeaderBodyTable}
          />
          <ApiCallComponent
            AllCodeImplementation={hourlyPriceWithVehicleCodeImplementation}
            title={"Price With Vehicle (Hourly)"}
          />
          <ResponseComp
            responseDescription={hourlyVehiclePricesDatas.responseDes}
            responsePayload={hourlyVehicleWithPrice.response}
          />
        </SubDescMain>

        <SubDescMain
          id={"Booking With Vehicle_HR"}
          header={"8.Booking With Vehicle (Hourly)"}
        >
          {hourlyBookingWithVehicleDatas.intro}
          <RequestUrl
            title={hourlyBookingWithVehicleDatas.endpoint}
            reqType={"POST"}
          />
          <Header />
          <BodyPara
            bodyEmpty={false}
            bodyTabHeader={HourlyBookingWithVehicleBodyTab.HeaderTable}
            bodyTableValues={HourlyBookingWithVehicleBodyTab.HeaderBodyTable}
            bodyPayload={hourlybookingCode.body}
          />
          <QueryPara
            queryEmpty={false}
            bodyTabHeader={HourlyBookingWithVehicleQueryTab.HeaderTable}
            bodyTableValues={HourlyBookingWithVehicleQueryTab.HeaderBodyTable}
          />
          <ApiCallComponent
            AllCodeImplementation={hourlyBookingWithVehicleCodeImplementation}
            title={"Booking With Vehicle (Hourly)"}
          />
          <ResponseComp
            responseDescription={hourlyBookingWithVehicleDatas.responseDes}
            responsePayload={hourlybookingCode.response}
          />
        </SubDescMain>
      </DescMain>

      <DescMain header={"Booking Details"}>
        <SubDescMain id={"Booking Details"} header={"9.Booking Details"}>
          {BookingStatusDatas.intro}
          <RequestUrl title={BookingStatusDatas.endpoint} reqType={"GET"} />
          <Header />
          <BodyPara
            bodyEmpty={false}
            bodyTabHeader={BookingDetailsbodyTab.HeaderTable}
            bodyTableValues={BookingDetailsbodyTab.HeaderBodyTable}
            bodyPayload={BookingDetailsCode.body}
          />
          <QueryPara
            queryEmpty={false}
            bodyTabHeader={BookingDetailsQueryTab.HeaderTable}
            bodyTableValues={BookingDetailsQueryTab.HeaderBodyTable}
          />
          <ApiCallComponent
            AllCodeImplementation={BookingDetailsCodeImplementation}
            title={"Booking Details"}
          />
          <ResponseComp
            responseDescription={BookingStatusDatas.responseDes}
            responsePayload={BookingDetailsCode.response}
          />
        </SubDescMain>
      </DescMain>

      <DescMain header={"Cancel Booking"}>
        <SubDescMain id={"Cancel Booking"} header={"9.Cancel Booking"}>
          {cancelBookingDatas.intro}
          <RequestUrl title={cancelBookingDatas.endpoint} reqType={"PATCH"} />
          <Header />
          <BodyPara
            bodyEmpty={false}
            bodyTabHeader={CancelBookingbodyTab.HeaderTable}
            bodyTableValues={CancelBookingbodyTab.HeaderBodyTable}
            bodyPayload={cancelBookingCode.body}
          />
          <QueryPara
            queryEmpty={false}
            bodyTabHeader={CancelBookingQueryTab.HeaderTable}
            bodyTableValues={CancelBookingQueryTab.HeaderBodyTable}
          />
          <ApiCallComponent
            AllCodeImplementation={cancelBookingCodeImplementation}
            title={"Cancel Booking"}
          />
          <ResponseComp
            responseDescription={cancelBookingDatas.responseDes}
            responsePayload={cancelBookingCode.response}
          />
        </SubDescMain>
      </DescMain>

      <DescMain header={"Driver Details And Tracking Link"}>
        <SubDescMain
          id={"Driver Details"}
          header={"10.Driver Details ( Tracking Link )"}
        >
          {DriverDetailsAndTrackingDatas.intro}
          <RequestUrl
            title={DriverDetailsAndTrackingDatas.endpoint}
            reqType={"GET"}
          />
          <Header />
          <BodyPara bodyEmpty={true} />
          <QueryPara
            queryEmpty={false}
            bodyTabHeader={DriverDetailsQueryTab.HeaderTable}
            bodyTableValues={DriverDetailsQueryTab.HeaderBodyTable}
          />
          <ApiCallComponent
            AllCodeImplementation={trackingAndDriverDetailsCodeImplementation}
            title={"Cancel Booking"}
          />
          <ResponseComp
            responseDescription={DriverDetailsAndTrackingDatas.responseDes}
            responsePayload={trackingAndDriverDetailsCode.response}
          />
        </SubDescMain>
      </DescMain>
    </div>
  );
};

export default DescriptionV2;
